import * as Dropdown from './Dropdown'

export const OnboardingForms = {
  Dropdown,
}
